/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { EduNetInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduNetApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EduNets');
  }

  find(params?): Observable<EduNetInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<EduNetInterface[]>(path, httpParams);
  }

  getEduNets(params: HttpParams): Observable<{ count: number; results: EduNetInterface[] }> {
    const path = 'search';
    return this.get(path, params);
  }

  public deleteEduNetById(id: number): Observable<boolean> {
    return this.delete(`${id}`).pipe(map((res) => !!res));
  }

  public create(eduNet: EduNetInterface): Observable<EduNetInterface> {
    return this.post(null, null, eduNet);
  }

  public update(params: HttpParams, eduNet: EduNetInterface): Observable<EduNetInterface> {
    return this.put(null, params, eduNet);
  }
}
